import { Dispatch } from "redux";
import { Auth2FaVerificationResponse } from "../../../models/auth2FaData";
import { auth2FaService } from "../../../api/index";
import {
  AUTH_2FA_RESEND_CODE_SUCCESS,
  AUTH_2FA_RESEND_CODE_FAILURE,
  AUTH_2FA_RESEND_CODE_REQUEST,
  Auth2FaResendCodeRequestAction,
  Auth2FaResendCodeFailureAction,
  Auth2FaResendCodeSuccessAction,
  Auth2FaResendCodeActionTypes,
} from "./types";

/**
 * Action to resend the 2FA code to the user.
 * @param {string} user_id - The ID of the user.
 */

export const resend2FaCode = (user_id: string) => {
  return async (dispatch: Dispatch<Auth2FaResendCodeActionTypes>) => {
    dispatch(resend2FaRequest());
    try {
      const data = await auth2FaService.resend2FaCode(user_id);
      dispatch(resend2FaSuccess(data));
      return data;
    } catch (error) {
      dispatch(resend2FaFailure());
      throw error;
    }
  };
};

/**
 * Action creator for requesting to resend the 2FA code.
 * @returns {Auth2FaResendCodeRequestAction} The action object.
 */
export function resend2FaRequest(): Auth2FaResendCodeRequestAction {
  return {
    type: AUTH_2FA_RESEND_CODE_REQUEST,
  };
}
/**
 * Action creator for failed 2FA code resend.
 * @returns {Auth2FaResendCodeFailureAction} The action object.
 */
export function resend2FaFailure(): Auth2FaResendCodeFailureAction {
  return {
    type: AUTH_2FA_RESEND_CODE_FAILURE,
  };
}

/**
 * Action to load the 2FA resend code success response.
 * @returns {Auth2FaResendCodeSuccessAction} The action object.
 */
export function resend2FaSuccess(
  data: Auth2FaVerificationResponse
): Auth2FaResendCodeSuccessAction {
  return {
    type: AUTH_2FA_RESEND_CODE_SUCCESS,
    data,
  };
}
